export default __webpack_public_path__ + "static/media/spinner.ab6cafe8.gif";